import type { EligibleTrainingItemsVM } from "@academy-context/shared/domain/types/eligible-training-items";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrieveEligibleTrainingItems = createApiThunk<EligibleTrainingItemsVM, void>(
  "student/retrieveEligibleTrainingItems",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getEligibleTrainingItems();
  },
);
